import api from './api';

export const vendorService = {
  async getVendors(weddingId, organizationId) {
    const response = await api.get(`/api/vendors?wedding_id=${weddingId}&organization_id=${organizationId}`);
    return response.data;
  },

  async getVendor(vendorId) {
    const response = await api.get(`/api/vendors/${vendorId}`);
    return response.data;
  },

  async createVendor(weddingId, organizationId, vendorData) {
    const response = await api.post(`/api/vendors?wedding_id=${weddingId}&organization_id=${organizationId}`, vendorData);
    return response.data;
  },

  async updateVendor(vendorId, vendorData) {
    const response = await api.put(`/api/vendors/${vendorId}`, vendorData);
    return response.data;
  },

  async deleteVendor(vendorId) {
    const response = await api.delete(`/api/vendors/${vendorId}`);
    return response.data;
  }
};
